import validateInvoicingItems from './invoicing-items.schema.json'

export default (value, args) => {
  return validateInvoicingItems(value)
}
